// mui
import { Stack, Typography } from '@mui/material';

// mui icons
import {
    Block as BlockIcon,
    SmartDisplay as SmartDisplayIcon,
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon,
} from '@mui/icons-material';

// client-shared
import { number, path } from '@goldblack/client-utils';

import { def } from '@goldblack/shared';

function PostShowMediaOverlay(post, hideBlocked = false) {
    if (!hideBlocked && post.status === def.PostStatus.BLOCKED) {
        return [
            <Stack
                key='statusOverlay'
                direction='column'
                justifyContent='center'
                alignItems='center'
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    pointerEvents: 'none',
                }}>
                <BlockIcon sx={{ fontSize: 22, color: 'white' }} />
            </Stack>,
        ];
    }
    if (!hideBlocked && post.status === def.PostStatus.CENSORED) {
        return [
            <Stack
                key='statusOverlay'
                direction='column'
                justifyContent='center'
                alignItems='center'
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    pointerEvents: 'none',
                }}>
                <VisibilityOffIcon sx={{ fontSize: 22, color: 'white' }} />
            </Stack>,
        ];
    }

    const isVideo = path.getContentType(post.image).startsWith('video');

    return [
        isVideo ? (
            <Stack
                key='videoOverlay'
                direction='row'
                justifyContent='center'
                alignItems='center'
                style={{ position: 'absolute', top: '0%', right: '0%' }}>
                <SmartDisplayIcon sx={{ m: 0, fontSize: '24px', color: 'white' }} />
            </Stack>
        ) : null,
        <Stack
            key='bottomAlpha'
            sx={{
                position: 'absolute',
                bottom: '0%',
                left: '0%',
                background: 'linear-gradient(#00000000, #0000007f)',
                width: '100%',
                height: '25%',
            }}
        />,
        <Stack
            key='viewCount'
            direction='row'
            justifyContent='center'
            alignItems='center'
            style={{ position: 'absolute', bottom: '0%', left: '0%' }}>
            <VisibilityIcon sx={{ m: 0.5, fontSize: '14px', color: 'white' }} />
            <Typography sx={{ ml: 0, fontSize: '14px', fontWeight: 'bold', color: 'white' }}>
                {number.formatNumber(post?.views, 1)}
            </Typography>
        </Stack>,
    ];
}

export { PostShowMediaOverlay };
